import { DivisionForm } from 'components/forms/division-form/division-form';
import { useCallback } from 'react';
import { getAgenciesWithDivisionsThunk } from 'store/agencies/agencies.thunks';
import { removeDivisionFromStore } from 'store/divisions/divisions.slice';
import { closeModal } from 'store/modals/modals.slice';

import { MODAL_DIVISION } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const DivisionModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === MODAL_DIVISION),
  );
  const isDirty = useAppSelector((state) => state.formIsDirty.isDirty);
  const isPending = useAppSelector(
    (state) => state.divisions.isCreateUpdateDivisionThunkPending,
  );

  const handleClose = useCallback(() => {
    if (isPending) {
      return;
    }

    dispatch(closeModal({ name: MODAL_DIVISION }));
    dispatch(removeDivisionFromStore());
    dispatch(getAgenciesWithDivisionsThunk());
  }, [dispatch, isPending]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal
      formIsDirty={isDirty}
      close={handleClose}
      canClose={!isPending}
      forDivision
    >
      <DivisionForm />
    </Modal>
  );
};
